import { useDispatch } from "react-redux";
import { confirmLogout } from "../store/uiSlice";
import { logout } from "../store/authSlice";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { IconSun, IconMoon, IconPower } from '@tabler/icons-react';
import { Button } from "./ui/button";
import { SidebarTrigger } from "./ui/sidebar";

const Navbar = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  
  // Check for system preference and set initial theme
  const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const [theme, setTheme] = useState(systemPrefersDark ? 'dark' : 'light');

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    
    const handleChange = (e) => {
      setTheme(e.matches ? 'dark' : 'light');
    };

    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  useEffect(() => {
    if (theme === 'dark') {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  };

  const onLogout = () => {
    dispatch(confirmLogout(logout.type));
  };

  const getPageTitle = () => {
    const path = location.pathname;
    
    const routeTitles = {
      '/': 'Dashboard',
      '/app_config': 'App Config',
      '/curriculum': 'Curriculum',
      '/system': 'System'
    };
    
    const patternTitles = [
      { pattern: /^\/curriculum\/programs\/\d+$/, title: 'Program Details' },
      { pattern: /^\/curriculum\/programs\/.*\/courses$/, title: 'Program Courses' },
      { pattern: /^\/curriculum\/programs\/new$/, title: 'Create Program' },
      { pattern: /^\/curriculum\/courses\/\d+$/, title: 'Course Details' },
      { pattern: /^\/curriculum\/courses\/.*\/lessons$/, title: 'Course Lessons' },
      { pattern: /^\/curriculum\/courses\/new$/, title: 'Create Course' },
      { pattern: /^\/curriculum\/lessons\/\d+$/, title: 'Lesson Details' },
      { pattern: /^\/curriculum\/lessons\/new$/, title: 'Create Lesson' },
      { pattern: /^\/curriculum\/lessons\/.*\/details$/, title: 'Lesson Details' }
    ];
    
    // Check exact matches first
    if (routeTitles[path]) {
      return routeTitles[path];
    }
    
    // Check pattern matches
    const matchedPattern = patternTitles.find(({ pattern }) => pattern.test(path));
    if (matchedPattern) {
      return matchedPattern.title;
    }
    
    return 'Dashboard';
  };

  return (
    <header className="flex h-16 shrink-0 items-center gap-2 border-b border-border bg-background px-4">
      <div className="flex items-center gap-2">
        <SidebarTrigger className="-ml-1" />
        <div className="h-4 w-px bg-border" />
        <div className="flex items-center">
          <h1 className="text-lg font-semibold text-foreground">
            {getPageTitle()}
          </h1>
        </div>
      </div>
      <div className="ml-auto flex items-center gap-2">
        <Button variant="ghost" size="icon" onClick={toggleTheme}>
          {theme === 'dark' ? (
            <IconSun className="h-4 w-4 text-foreground" />
          ) : (
            <IconMoon className="h-4 w-4 text-foreground" />
          )}
        </Button>
        
        <Button variant="ghost" size="icon" onClick={onLogout}>
          <IconPower className="h-4 w-4 text-foreground" />
        </Button>
      </div>
    </header>
  );
};

export default Navbar;